var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinWinnerTrophy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 35,
    viewBox: "0 0 46 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.435 6.98616C40.4992 4.72227 41.2635 11.2255 39.6413 13.886C38.0839 16.4527 33.1235 16.2508 31.112 16.6978C29.1077 17.1376 30.4199 19.7476 30.4199 19.7476L42.7127 15.7894L44.1546 7.55574L39.7494 5.59467C39.7494 5.59467 38.0479 5.94794 37.435 6.98616Z",
    fill: "url(#paint0_linear_2390_49637)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53148 6.98616C5.4673 4.72227 4.70305 11.2255 6.31805 13.886C7.87538 16.4527 12.8357 16.2508 14.8473 16.6978C16.8516 17.1376 15.5394 19.7476 15.5394 19.7476L3.24666 15.7894L1.80469 7.55574L6.20991 5.59467C6.20991 5.59467 7.91143 5.94794 8.52426 6.98616H8.53148Z",
    fill: "url(#paint1_linear_2390_49637)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8021 6.6617C34.8021 6.6617 37.0156 4.85924 42.2427 4.98902C47.4626 5.11879 44.831 13.9076 42.769 16.7915C40.7863 19.5601 33.8721 18.3416 32.5959 19.0626C31.327 19.7764 32.4013 21.4419 31.8821 21.7303C31.363 22.0187 29.748 20.3171 30.1302 18.8607C30.5267 17.3755 37.8086 16.532 40.4042 14.1599C43.0935 11.7014 42.2427 6.84915 39.8707 6.53192C37.1093 6.16422 36.7921 7.60619 36.619 9.24283C36.446 10.8434 33.8144 11.2544 33.8144 11.2544L34.8093 6.6545L34.8021 6.6617Z",
    fill: "url(#paint2_linear_2390_49637)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3125 21.752C14.226 21.7664 14.1611 21.7664 14.1394 21.7664C14.1394 21.7664 14.0746 21.752 14.0457 21.7376C13.5194 21.442 14.6009 19.7837 13.3319 19.0699C12.0558 18.349 5.14156 19.5674 3.15885 16.7988C1.08963 13.9149 -1.53474 5.12611 3.68518 4.99634C8.91231 4.86656 11.133 6.66181 11.133 6.66181L12.1279 11.2689C12.1279 11.2689 9.4891 10.8579 9.32328 9.25735C9.15024 7.62072 8.833 6.17874 6.07163 6.54645C3.69239 6.86368 2.84163 11.7087 5.53811 14.1673C8.13365 16.5393 15.4156 17.3828 15.8121 18.8681C15.8266 18.9329 15.841 18.9978 15.8554 19.0627C16.0284 20.2668 14.9614 21.5717 14.3341 21.752H14.3125Z",
    fill: "url(#paint3_linear_2390_49637)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9849 19.5674C31.336 18.5652 36.0945 16.3734 38.791 15.9841C41.5019 15.5948 42.2734 16.7916 42.2517 17.08C42.2301 17.3684 41.3 18.3706 38.0051 18.6662C34.7246 18.9618 33.0231 18.4787 31.9849 19.5674Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88409 18.3561C2.5243 16.8637 9.18619 16.5176 12.0052 17.2747C14.7882 18.0245 14.5575 19.6972 14.2331 19.7476C13.9086 19.7909 14.0961 19.0195 12.9137 18.9329C11.7241 18.8392 7.10256 18.7599 5.8913 18.3633L5.88409 18.3561Z",
    fill: "#FF4D74"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86816 5.59466C4.21136 3.5759 10.7146 4.39061 10.7146 4.39061L11.1184 6.66171C11.1184 6.66171 4.52138 3.9436 1.86816 5.59466Z",
    fill: "url(#paint4_linear_2390_49637)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0512 3.77067C36.0512 3.77067 42.2589 3.56159 43.6504 5.33521C43.6504 5.33521 41.0404 4.01581 35.2148 6.39505L36.0512 3.77788V3.77067Z",
    fill: "url(#paint5_linear_2390_49637)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0502 4.17444C36.0502 4.17444 34.7164 9.81974 33.3609 13.8068C33.3465 13.85 33.3249 13.9005 33.3105 13.9582C33.2961 13.9942 33.2816 14.0231 33.2744 14.0663C32.813 15.4002 32.3516 16.5249 31.9478 17.1521C30.3761 19.5747 24.5217 22.1269 23.8007 26.6187C23.6205 27.7218 23.8512 28.5653 24.2982 29.2142C25.5455 31.0455 28.4871 31.3699 28.9629 31.6944C28.9774 31.7088 28.9918 31.716 29.0062 31.7304C29.619 32.2135 30.1958 33.6771 30.1958 33.6771C30.1958 33.6771 26.9802 34.1674 22.9139 34.1674C18.8475 34.1674 15.6752 33.6771 15.6752 33.6771C15.6752 33.6771 16.2809 32.1414 16.9081 31.6944C17.384 31.3627 20.4986 31.0311 21.7459 29.1277C22.1713 28.486 22.3804 27.6713 22.2145 26.6115C21.5008 22.1197 15.4878 19.5602 13.916 17.1449C13.0004 15.739 12.1136 11.925 11.5007 8.83199C11.0177 6.39506 10.7148 4.40515 10.7148 4.40515L23.0076 6.36622L36.043 4.17444H36.0502Z",
    fill: "url(#paint6_linear_2390_49637)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0318 3.25154C13.8797 0.0936297 28.2633 -1.82419 34.9901 2.58102C42.5965 7.55581 6.61939 8.14702 11.0318 3.25154Z",
    fill: "url(#paint7_linear_2390_49637)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4221 3.6913C16.9455 5.87588 30.1612 5.87588 32.7711 3.66246C34.5448 2.16281 28.9211 0.872253 23.3334 0.929932C17.9765 0.980401 12.8359 2.31422 14.4221 3.6913Z",
    fill: "url(#paint8_linear_2390_49637)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2747 14.059C32.8132 15.3928 32.3518 16.5176 31.9481 17.1448C30.3763 19.5673 24.5219 22.1196 23.801 26.6113C23.6207 27.7144 23.8514 28.558 24.2984 29.2069C22.9862 30.584 22.3229 30.1874 21.7461 29.1204C22.1715 28.4787 22.3806 27.664 22.2148 26.6041C21.501 22.1124 15.488 19.5529 13.9163 17.1376C13.0006 15.7317 12.1138 11.9177 11.501 8.82467L11.5586 8.68768C11.5586 8.68768 12.5968 17.6783 19.6697 19.7476C26.6632 21.7952 32.1643 17.0871 33.2674 14.0518L33.2747 14.059Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0859 18.6445C16.3743 18.0173 19.5827 20.6056 22.3873 21.4348C25.192 22.2639 22.9281 24.1745 21.8898 23.8789C20.8516 23.5833 16.6772 19.2646 16.0932 18.6445H16.0859Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1974 33.6698C30.1974 33.6698 26.9818 34.1601 22.9154 34.1601C18.8491 34.1601 15.6768 33.6698 15.6768 33.6698C15.6768 33.6698 16.2824 32.1341 16.9097 31.6871C16.5924 33.0498 27.1837 32.0043 29.015 31.7231C29.6278 32.2062 30.2046 33.6698 30.2046 33.6698H30.1974Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4422 34.1385C22.6037 33.814 22.3442 32.8479 23.3824 32.3432C24.0096 32.0404 25.329 32.0981 26.4321 32.0188C29.3593 31.8097 29.8064 33.504 29.7415 33.6266C29.6766 33.7492 25.9779 34.1241 24.4422 34.1457V34.1385Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6335 32.3648C19.4461 32.3648 19.2875 33.7275 19.4965 33.8933C19.7056 34.0592 21.6451 34.1168 21.9695 34.1385C22.2939 34.1601 22.64 32.6821 22.9356 32.473C23.2312 32.2639 19.6335 32.3648 19.6335 32.3648Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0852 32.2495C17.9965 32.2063 19.6476 30.7355 22.0484 30.7355C24.4493 30.7355 25.4082 31.442 25.4731 31.68C25.5308 31.9179 21.9475 32.3649 19.0924 32.2423L19.0852 32.2495Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7405 5.59477C12.0195 5.33522 12.4449 17.8154 19.6691 19.7477C26.8934 21.6799 32.755 10.1658 33.2669 7.82261C33.7788 5.47941 25.0332 7.58468 19.3879 6.69066C13.7426 5.80385 12.7333 5.58755 12.7333 5.58755L12.7405 5.59477Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2996 1.4563C23.9016 1.83121 24.6009 4.56374 25.2426 5.07564C25.8843 5.58754 31.6882 4.43396 32.5461 3.26596C33.4041 2.09797 28.2996 1.4563 28.2996 1.4563Z",
    fill: "#FF450C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2999 1.4563C26.5263 1.80958 28.6532 3.37412 29.5256 3.33086C30.3979 3.28039 31.328 2.06193 30.6719 1.91052C30.0158 1.75912 28.2999 1.4635 28.2999 1.4635V1.4563Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9302 5.32794C39.6057 5.64518 41.8624 6.61129 42.4536 9.67548C43.0448 12.7397 45.1356 10.0792 45.0347 7.82255C44.9266 5.56587 42.2157 4.85209 39.9302 5.32794Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10451 9.7837C1.22708 11.7952 2.67626 12.7325 2.95745 12.6748C3.23863 12.6172 2.71231 7.64958 6.18025 5.96969C7.65826 5.25592 2.14274 5.45779 1.63084 5.96969C1.11894 6.48159 0.989157 7.82984 1.10451 9.7837Z",
    fill: "#FF4D74"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9188 7.13765C13.6859 7.72886 15.0774 9.5169 15.6686 9.40154C16.2598 9.28619 16.1517 6.54645 14.9188 7.13765Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3018 5.45047C12.3018 5.45047 24.0321 7.13036 31.9269 5.92632C31.9269 5.92632 20.8815 7.82972 12.3018 5.45047Z",
    fill: "#FFE861"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1876 10.9444C33.1659 11.0598 33.1227 11.1824 33.0722 11.3049C32.5892 12.3503 30.9093 13.5183 29.9864 13.0281C29.6692 12.8622 29.4962 12.6099 29.4313 12.2999C29.2006 11.2256 30.2387 9.48083 30.8804 8.45704C31.7096 7.13043 33.3895 9.8269 33.1876 10.9444Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8609 14.1673C28.8177 14.4845 28.724 14.8738 28.587 15.3208C28.2769 16.323 27.282 15.5948 27.008 14.8017C26.9575 14.6647 26.9287 14.535 26.9287 14.4052C26.9287 13.5184 27.8227 12.7397 28.587 13.1363C28.8465 13.2733 28.9258 13.6337 28.8609 14.1673Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1876 10.9444C33.1659 11.0598 33.1227 11.1824 33.0722 11.3049L33.0001 11.3193C33.0001 11.3193 33.065 11.0021 32.7694 10.1009C32.4738 9.19965 31.6951 8.16143 30.8372 8.92567C29.9936 9.68991 29.4529 12.2206 29.4313 12.2999C29.2006 11.2256 30.2387 9.48083 30.8804 8.45704C31.7096 7.13043 33.3895 9.8269 33.1876 10.9444Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8609 14.1673C28.8609 14.1673 28.2337 13.0353 27.6209 13.2877C27.008 13.5472 27.008 14.8017 27.008 14.8017C26.9575 14.6647 26.9287 14.535 26.9287 14.4052C26.9287 13.5184 27.8227 12.7397 28.587 13.1363C28.8465 13.2733 28.9258 13.6337 28.8609 14.1673Z",
    fill: "#E56D8D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1836 11.1823C34.1836 11.1823 35.6184 10.4757 36.3465 9.27166C37.0747 8.06762 35.8491 4.98901 35.8491 4.98901L34.1836 11.1895V11.1823Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8599 5.19093C10.8599 5.19093 10.658 6.25799 10.4129 6.39497C10.1678 6.53196 9.21604 8.55793 9.69189 9.71871C10.1677 10.8795 12.1216 11.2616 12.1216 11.2616C12.1216 11.2616 11.1483 7.74321 10.8599 5.18372V5.19093Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87207 9.71869C4.08116 11.7951 4.73003 12.1051 5.16983 11.9465C5.60963 11.7951 4.95353 7.42596 7.12369 6.49589C7.12369 6.49589 3.9658 6.2796 3.87207 9.71869Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4316 6.63293C39.4893 6.89249 41.1476 9.04102 41.1404 11.1823C41.1259 13.3309 42.5463 8.99775 41.3927 7.61346C40.2391 6.22917 39.4389 6.63293 39.4389 6.63293H39.4316Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32175 14.4196C4.2619 14.2033 5.98505 16.8061 8.09033 16.8926C10.1884 16.9791 10.8445 16.8926 10.8445 16.8926C10.8445 16.8926 5.9418 14.5422 5.32175 14.4196Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5766 16.15C36.5766 16.15 40.2536 16.1067 41.1115 15.6669C41.9695 15.2343 42.0632 13.4823 41.8397 13.3814C41.6234 13.2732 40.7583 14.2682 39.0928 15.0757C37.4273 15.8832 36.5693 16.15 36.5693 16.15H36.5766Z",
    fill: "#FF450C"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6807 5.59483C37.1039 5.73902 37.2625 4.59266 38.964 4.41241C40.3627 4.26822 40.9034 5.00362 40.9034 5.00362C40.9034 5.00362 40.1825 4.97478 37.6807 5.59483Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07122 5.22698C5.34303 4.75834 10.7144 4.93138 9.11377 5.96239C9.11377 5.96239 7.73669 5.45049 6.07122 5.22698Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6342 32.3649C18.6897 32.2712 20.3624 31.2114 21.5376 31.6872C22.72 32.1631 21.7827 32.574 19.6342 32.3649Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8315 15.6668C37.7017 15.8471 39.1437 15.7966 39.4897 15.1405C39.8358 14.4844 38.0982 15.2847 37.8315 15.6668Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69192 16.2725C9.73518 16.5321 7.62991 16.1139 7.70922 15.6741C7.78853 15.2343 9.64145 15.9409 9.69192 16.2725Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1316 18.8679C31.5231 17.6855 31.3068 21.6005 31.3068 21.6005C31.3068 21.6005 29.6846 20.209 30.1316 18.8679Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3118 21.752C14.2253 21.7665 14.1604 21.7665 14.1387 21.7665C14.0594 21.3267 14.9462 18.6302 15.8403 19.0628C16.0133 20.2668 14.9462 21.5718 14.319 21.752H14.3118Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1318 3.21553C14.2328 2.4657 18.0756 1.02374 20.4116 1.45633C22.7476 1.88892 24.9394 4.67913 24.7663 4.99636C24.5933 5.31359 15.3215 5.5371 14.1318 3.21553Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.474 22.5161C24.5944 22.5666 23.4841 21.55 24.169 20.9516C25.3154 19.9566 29.1655 18.9977 30.5065 17.736L32.655 15.7173C32.655 15.7173 32.1576 17.1953 30.3984 18.7021C28.6392 20.2018 25.9138 22.5017 25.474 22.5233V22.5161Z",
    fill: "#DE5155"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7035 13.4533C28.8116 16.5679 26.4035 19.1923 23.3249 19.1923C20.2463 19.1923 17.831 16.5679 17.9463 13.4533C18.0545 10.4612 20.4626 8.11801 23.3249 8.11801C26.1872 8.11801 28.6025 10.4612 28.7035 13.4533Z",
    fill: "url(#paint9_linear_2390_49637)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 15.4144C18.8975 13.4245 28.0252 12.0474 28.501 12.5593C28.9841 13.0784 27.9314 18.6589 23.4902 18.7165C19.0489 18.767 18.263 15.9624 18.4 15.4216V15.4144Z",
    fill: "white"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0504 15.0531C24.0504 15.4294 23.9856 15.7093 23.8559 15.8927C23.7263 16.0761 23.5255 16.1678 23.2535 16.1678C22.9847 16.1678 22.7839 16.0761 22.6511 15.8927C22.5215 15.7093 22.4566 15.4294 22.4566 15.0531V10.6513H22.3143C21.9665 10.6513 21.7024 10.5896 21.5222 10.4663C21.3419 10.3429 21.2518 10.1611 21.2518 9.92078C21.2518 9.67729 21.3435 9.49546 21.5269 9.37529C21.7135 9.25513 21.9949 9.19504 22.3712 9.19504H23.1586C23.478 9.19504 23.7057 9.28042 23.8417 9.45118C23.9808 9.62195 24.0504 9.90813 24.0504 10.3097V15.0531Z",
    fill: "#FFE228"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0504 15.2069C24.0504 15.5832 23.9856 15.863 23.8559 16.0464C23.7263 16.2299 23.5255 16.3216 23.2535 16.3216C22.9847 16.3216 22.7839 16.2299 22.6511 16.0464C22.5215 15.863 22.4566 15.5832 22.4566 15.2069V10.805H22.3143C21.9665 10.805 21.7024 10.7434 21.5222 10.62C21.3419 10.4967 21.2518 10.3149 21.2518 10.0746C21.2518 9.83106 21.3435 9.64923 21.5269 9.52907C21.7135 9.4089 21.9949 9.34882 22.3712 9.34882H23.1586C23.478 9.34882 23.7057 9.4342 23.8417 9.60496C23.9808 9.77572 24.0504 10.0619 24.0504 10.4635V15.2069Z",
    fill: "#FFA400"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9395 13.4535C17.9395 13.4535 19.1435 8.77432 23.491 8.77432C27.6078 8.77432 28.6028 12.4009 28.6028 12.4009C28.6028 12.4009 27.8746 7.99567 23.1882 8.11823C18.4946 8.2408 17.9395 12.9488 17.9395 13.4535Z",
    fill: "#BE2F55"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7256 16.5393C18.7256 16.5393 20.3046 19.3367 23.6644 19.1853C27.0241 19.0339 28.3219 15.6958 28.3219 15.6958C28.3219 15.6958 26.7501 19.7044 23.4913 19.7117C20.2324 19.7189 18.7256 16.5393 18.7256 16.5393Z",
    fill: "url(#paint10_linear_2390_49637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2390_49637",
    x1: 29.9945,
    y1: 12.6747,
    x2: 44.1474,
    y2: 12.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2390_49637",
    x1: 15.9648,
    y1: -112.38,
    x2: 1.8119,
    y2: -112.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2390_49637",
    x1: 37.6789,
    y1: 21.7735,
    x2: 37.6789,
    y2: 4.98902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2390_49637",
    x1: 8.2418,
    y1: 21.7664,
    x2: 8.2418,
    y2: 4.98913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2390_49637",
    x1: 1.86816,
    y1: 5.45046,
    x2: 11.1256,
    y2: 5.45046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2390_49637",
    x1: 35.2148,
    y1: 5.08286,
    x2: 43.6504,
    y2: 5.08286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2390_49637",
    x1: 10.7221,
    y1: 19.1709,
    x2: 36.0502,
    y2: 19.1709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2390_49637",
    x1: 10.6569,
    y1: 3.31642,
    x2: 36.0499,
    y2: 3.31642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2390_49637",
    x1: 15.6398,
    y1: 3.37625,
    x2: 34.6678,
    y2: 2.75832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2390_49637",
    x1: 23.3249,
    y1: 19.6264,
    x2: 23.3249,
    y2: 8.51051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EF6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2390_49637",
    x1: 18.7256,
    y1: 17.7073,
    x2: 28.3291,
    y2: 17.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinWinnerTrophy1);
export default __webpack_public_path__ + "static/media/spin-winner-trophy1.8438bac4e7f99eae5187a4c0b0ac69cd.svg";
export { ForwardRef as ReactComponent };